import { Navigate, useNavigate } from 'react-router';
import { AuthLayout } from '../components/AuthLayout';
import { LoadingBlock } from '../components/ui';
import { useAuth } from '../context/AuthContext';
import { daysUntil, formatDate } from '../lib/format';
import { rolleEtikett } from '../lib/roller';

/**
 * Hvilket bryllup skal du inn i?
 *
 * Vises bare når man har mer enn ett – sitt eget, og ett man er toastmaster
 * eller forlover i. Med bare ett er dette et steg uten innhold, og da hoppes
 * det over.
 *
 * Sida er også en adresse man kan gå til senere, og ikke bare et steg i
 * innloggingen. Den som lurer på hvilke bryllup de har tilgang til, skal
 * kunne se det uten å logge ut og inn igjen.
 */
export function VelgBryllupPage() {
  const { status, weddings, activeWedding, selectWedding } = useAuth();
  const navigate = useNavigate();

  if (status === 'loading') return <LoadingBlock />;
  if (status === 'anonymous') return <Navigate to="/logg-inn" replace />;
  if (weddings.length === 0) return <Navigate to="/kom-i-gang" replace />;
  if (weddings.length === 1) return <Navigate to="/app" replace />;

  const velg = (id: string) => {
    selectWedding(id);
    navigate('/app');
  };

  return (
    <AuthLayout
      title="Hvilket bryllup?"
      subtitle="Du har tilgang til flere. Velg det du skal jobbe med nå – du kan bytte når som helst fra menyen."
    >
      <ul className="bryllupsvalg">
        {weddings.map((bryllup) => {
          const dager = daysUntil(bryllup.weddingDate);
          return (
            <li key={bryllup.id}>
              <button
                type="button"
                className={bryllup.id === activeWedding?.id ? 'sist-brukt' : ''}
                onClick={() => velg(bryllup.id)}
              >
                <span className="navn">
                  {bryllup.partner1Name} &amp; {bryllup.partner2Name}
                </span>
                <span className="rolle">{rolleEtikett(bryllup.role, bryllup.delingPaaPause)}</span>
                <span className="dato">
                  {bryllup.weddingDate ? formatDate(bryllup.weddingDate) : 'Dato ikke satt'}
                  {dager !== null && dager >= 0
                    ? ` · ${dager} ${dager === 1 ? 'dag' : 'dager'} igjen`
                    : ''}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </AuthLayout>
  );
}
